module.exports = __webpack_public_path__ + "static/img/avatar.5baf67bd.png";